import { Injectable } from '@angular/core';

import { newUuid } from '../pos-config.utils';

/**
 * PosConfigPagesService (Angular 18)
 *
 * Ported 1:1 from apps/b2b-ui/common/services/posConfig/posConfigPages/posConfigPages.service.js
 * (legacy name 'PosConfigPagesService'). Manages the POS display-item pages
 * collection (create/remove/find/select/default + ordering).
 *
 * Internal sub-service of PosConfigService — injected directly, not
 * downgrade-registered. Legacy `uuid2.newuuid()` → native `newUuid()`
 * (see pos-config.utils.ts). Wave 3 #17.
 */
@Injectable({ providedIn: 'root' })
export class PosConfigPagesService {
  selectedPage: any = false;
  defaultPage: any = false;

  model: any[] = [];

  init(): boolean {
    return true;
  }

  create(): any {
    const page = {
      pageId: newUuid(),
      configId: '',
      pageHeader: 'Untitled Page ' + (this.model.length + 1),
      name: '',
      pageNumber: this.model.length + 1,
      description: '',
      defaultPage: '',
      items: [],
    };

    this.model.push(page);

    return page;
  }

  remove(id: any): void {
    this.model.splice(this.findPage(id).index, 1);
    this.updateOrder();
  }

  getModel(): any[] {
    return this.model;
  }

  setModel(pages: any): void {
    this.model = pages instanceof Array ? pages : [];
  }

  // Get this.model.items
  getPageTiles(id: any): any {
    let r: any = false;
    const found = this.findPage(id);

    if (found) {
      if (found.page.items instanceof Array && found.page.items.length) {
        r = found.page.items;
      } else {
        r = found.page.items = [];
      }
    }

    return r;
  }

  removePageTile(id: any, tile: any): void {
    let i, ii;
    let page;
    const found = this.findPage(id);

    if (found) {
      page = found.page;

      for (i = 0, ii = page.items.length; i < ii; i++) {
        if (page.items[i].config.id === tile.config.id) {
          page.items.splice(i, 1);
          break;
        }
      }

      this.model[found.index] = page;
    }
  }

  findPage(id: any): any {
    let i, ii;
    let r: any = false;

    for (i = 0, ii = this.model.length; i < ii; i++) {
      if (this.model[i].pageId === id) {
        r = {
          page: this.model[i],
          index: i,
        };
        break;
      }
    }

    return r;
  }

  updatePage(page: any): void {
    const found = this.findPage(page.pageId);

    if (found) {
      this.model[this.findPage(found.page.pageId).index] = page;
    }
  }

  setSelectedPage(id: any): void {
    this.selectedPage = this.findPage(id).page.pageId;
  }

  getSelectedPage(): any {
    return this.findPage(this.selectedPage);
  }

  getSelectedPageId(): any {
    let r: any = false;
    const p = this.getSelectedPage();

    if (p) {
      r = p.page.pageId;
    }

    return r;
  }

  clearSelectedPage(): void {
    this.selectedPage = false;
  }

  setDefaultPage(id: any): void {
    this.defaultPage = this.findPage(id).page.pageId;
  }

  getDefaultPage(): any {
    return this.findPage(this.defaultPage);
  }

  getDefaultPageId(): any {
    let r: any = false;
    const p = this.getDefaultPage();

    if (p) {
      r = p.page.pageId;
    }

    return r;
  }

  clearDefaultPage(): void {
    this.defaultPage = false;
  }

  getEmptyPages(): any[] {
    let i, ii;
    let j, jj;
    let hasTiles;
    const r: any[] = [];

    for (i = 0, ii = this.model.length; i < ii; i++) {
      if (this.model[i].items.length === 0) {
        r.push(this.model[i].pageHeader);
      } else {
        hasTiles = false;
        for (j = 0, jj = this.model[i].items.length; j < jj; j++) {
          if (this.model[i].items[j].config.type !== 'tile') {
            hasTiles = true;
            break;
          }
        }
        if (!hasTiles) {
          r.push(this.model[i].pageHeader);
        }
      }
    }

    return r;
  }

  updateOrder(): void {
    let i, ii;

    for (i = 0, ii = this.model.length; i < ii; i++) {
      this.model[i].pageNumber = i + 1;
    }
  }

  canDelete(): boolean {
    return this.model instanceof Array && this.model.length > 1;
  }
}
